/* eslint-disable @typescript-eslint/no-explicit-any */
import { Reminder } from '../types';

export const dummyReminders: Reminder[] = [
  // Malorie Down's reminders for October 2nd appointment
  {
    id: 'rem-malorie-1',
    patientId: '56',
    patientName: 'Malorie Down',
    appointmentId: 'malorie-2',
    appointmentDate: '2025-10-02',
    appointmentTime: '10:00',
    appointmentType: 'consultation',
    type: 'appointment',
    title: 'Appointment Reminder - Wisdom Teeth Consultation',
    content: 'Hi Malorie! This is a friendly reminder about your upcoming appointment at Estrabillo Dental Clinic on October 2nd, 2025 at 10:00 AM for your wisdom teeth consultation and examination. Please arrive 15 minutes early for check-in. If you need to reschedule, please call us at (555) 123-4567. We look forward to seeing you!',
    scheduledDate: '2025-09-30',
    scheduledTime: '09:00',
    status: 'scheduled',
    method: 'sms',
    priority: 'medium',
    createdAt: new Date('2025-09-28T10:00:00Z')
  },
  {
    id: 'rem-malorie-2',
    patientId: '56',
    patientName: 'Malorie Down',
    appointmentId: 'malorie-2',
    appointmentDate: '2025-10-02',
    appointmentTime: '10:00',
    appointmentType: 'consultation',
    type: 'educational',
    title: 'Important Update on Your Wisdom Teeth Treatment',
    content: `Dear Malorie Down,

At Estrabillo Dental Clinic, we're focused on your oral health regarding your recent diagnosis of pericoronitis (Case ID: FR2A3CCQ6NS7H4NYN), causing swelling and chewing issues due to impacted wisdom teeth. Your treatment starts October 2, 2025, with key appointments on October 3, 4, and 5.

Pros of Attending: Relief from pain, 85% success rate, prevents complications, and long-term cost savings.

Cons of Missing: Worsening pain, higher risks, and increased costs later.

Please prioritize these short visits (0.5-1.5 minutes). You can reply if you need to reschedule. Your favorable prognosis depends on it!

Best,
Dr. Roland
Estrabillo Dental Clinic`,
    scheduledDate: '2025-09-30',
    scheduledTime: '14:00',
    status: 'scheduled',
    method: 'email',
    priority: 'high',
    caseId: 'FR2A3CCQ6NS7H4NYN',
    createdAt: new Date('2025-09-28T10:00:00Z')
  },
  {
    id: 'rem-malorie-3',
    patientId: '56',
    patientName: 'Malorie Down',
    appointmentId: 'malorie-2',
    appointmentDate: '2025-10-02',
    appointmentTime: '10:00',
    appointmentType: 'consultation',
    type: 'video',
    title: 'Educational Video: Understanding Your Wisdom Teeth Treatment',
    content: 'Hi Malorie! We\'ve prepared an educational video to help you understand your upcoming wisdom teeth treatment. This video explains the procedure, what to expect, and why completing your treatment plan is important for your oral health. Please watch this before your appointment on October 2nd. Video link: https://bit.ly/wisdom-teeth-edu',
    scheduledDate: '2025-10-03',
    scheduledTime: '14:00',
    status: 'scheduled',
    method: 'email',
    priority: 'medium',
    videoUrl: 'https://drive.google.com/file/d/1QtJjyWPoG8YWl5PVS_fo3y41hXx5xtJs/view?usp=sharing',
    caseId: 'FR2A3CCQ6NS7H4NYN',
    createdAt: new Date('2025-09-28T10:00:00Z')
  },
  {
    id: 'rem-malorie-4',
    patientId: '56',
    patientName: 'Malorie Down',
    appointmentId: 'malorie-3',
    appointmentDate: '2025-10-05',
    appointmentTime: '14:00',
    appointmentType: 'procedure',
    type: 'appointment',
    title: 'Pre-operative Appointment Reminder',
    content: 'Hi Malorie! This is a reminder about your pre-operative antibiotic therapy appointment on October 5th, 2025 at 2:00 PM. This is an important step before your wisdom teeth extraction. Please take any prescribed medications as directed and avoid eating 2 hours before your appointment. Call us if you have any questions!',
    scheduledDate: '2025-10-03',
    scheduledTime: '10:00',
    status: 'scheduled',
    method: 'sms',
    priority: 'high',
    caseId: 'FR2A3CCQ6NS7H4NYN',
    createdAt: new Date('2025-09-28T10:00:00Z')
  },

  // Additional reminders for other patients
  {
    id: 'rem-maria-1',
    patientId: '1',
    patientName: 'Maria Elena Rodriguez',
    appointmentId: '1',
    appointmentDate: '2025-01-15',
    appointmentTime: '09:00',
    appointmentType: 'cleaning',
    type: 'appointment',
    title: 'Recordatorio de Cita - Limpieza Dental',
    content: '¡Hola María! Este es un recordatorio amistoso sobre su cita en Estrabillo Dental Group el 15 de enero de 2025 a las 9:00 AM para su limpieza dental de rutina. Por favor llegue 15 minutos antes. Si necesita reprogramar, llámenos al (555) 123-4567. ¡Esperamos verla!',
    scheduledDate: '2025-01-13',
    scheduledTime: '10:00',
    status: 'scheduled',
    method: 'sms',
    priority: 'medium',
    createdAt: new Date('2025-01-10T10:00:00Z')
  },
  {
    id: 'rem-james-1',
    patientId: '2',
    patientName: 'James Patterson',
    appointmentId: '2',
    appointmentDate: '2025-01-16',
    appointmentTime: '14:30',
    appointmentType: 'consultation',
    type: 'appointment',
    title: 'Crown Consultation Reminder',
    content: 'Hi James! Reminder about your crown consultation appointment on January 16th, 2025 at 2:30 PM. We\'ll be discussing your crown replacement options. Please bring your insurance card and any questions you may have. Looking forward to seeing you!',
    scheduledDate: '2025-01-14',
    scheduledTime: '11:00',
    status: 'scheduled',
    method: 'email',
    priority: 'medium',
    createdAt: new Date('2025-01-11T10:00:00Z')
  }
];

// Function to generate reminders for appointments
export function generateRemindersForAppointment(appointment: any, patient: any): Reminder[] {
  const reminders: Reminder[] = [];
  const appointmentDate = new Date(appointment.date);
  
  // Calculate reminder dates (2-3 days before)
  const reminderDate1 = new Date(appointmentDate);
  reminderDate1.setDate(appointmentDate.getDate() - 2);
  
  const reminderDate2 = new Date(appointmentDate);
  reminderDate2.setDate(appointmentDate.getDate() - 3);

  // Basic appointment reminder
  reminders.push({
    id: `rem-${appointment.id}-basic`,
    patientId: patient.id,
    patientName: patient.name,
    appointmentId: appointment.id,
    appointmentDate: appointment.date,
    appointmentTime: appointment.time,
    appointmentType: appointment.type,
    type: 'appointment',
    title: `Appointment Reminder - ${appointment.type}`,
    content: `Hi ${patient.name}! This is a friendly reminder about your upcoming ${appointment.type} appointment on ${appointment.date} at ${appointment.time}. Please arrive 15 minutes early. Call us if you need to reschedule.`,
    scheduledDate: reminderDate1.toISOString().split('T')[0],
    scheduledTime: '10:00',
    status: 'scheduled',
    method: patient.language === 'es' ? 'sms' : 'email',
    priority: appointment.type === 'emergency' ? 'high' : 'medium',
    createdAt: new Date()
  });

  return reminders;
}